import { get } from 'lodash'
import { connect } from 'react-redux'

import { auth } from '../../../../constants/actions'
import withRecaptcha from '../../../../hoc/withRecaptcha'
import { getHierarchyCountryCode } from '../../../../selectors/formInfo'
import Signup from './component'

export const mapStateToProps = state => ({
  eventLogo: get(state, 'formSettings.eventLogo'),
  orgLogo: get(state, 'formSettings.orgLogo'),
  landingPageLogo: get(state, 'formSettings.landingPageLogo'),
  formType: get(state, 'formSettings.formType'),
  signUpMsg: get(state, 'auth.signUpMsg.message'),
  isSubmitPending: get(state, 'common.showLoadingIndicator'),
  hierarchyCountryCode: getHierarchyCountryCode(state),
})

export default connect(mapStateToProps, {
  signUp: auth.signUp,
  setSignupMsg: auth.setSignupMsg,
  verifyEmail: auth.verifyEmail,
})(withRecaptcha('Signup')(Signup))
